import { Dialog } from '@mui/material';
import { FC, memo } from 'react';
import DirectionSettingDialog from 'src/components/DirectionSettingDialog';
import SelectPrintPresenter from 'src/pages/V3Plans/presenters/SelectPrintPresenter';
import ShipperSelectDialog from 'src/pages/V3Plans/presenters/ShipperSelectDialog';

import type { ReportPrintingDialogProps } from './useReportPrinting';

/**
 * V3Plans / ConvenienceDispatches で共有する帳票出力 (印刷) ダイアログ群。
 * 個別の出力ボタンや state は useReportPrinting hook が持つので、
 * 呼び出し側はこのコンポーネントを 1 つマウントし、ボタンの onClick で hook の `open` を呼べば良い。
 */
const ReportPrintingDialogs: FC<ReportPrintingDialogProps> = memo((props) => (
  <>
    <Dialog open={props.selectPrintDialogOpen} onClose={props.onCloseSelectPrint}>
      <SelectPrintPresenter
        printAllOperationDirectionsOnClick={props.printAllOperationDirectionsOnClick}
        printAllTruckDirectionsOnClick={props.printAllTruckDirectionsOnClick}
        printUnloadTruckDirectionsOnClick={props.printUnloadTruckDirectionsOnClick}
        printPickingListOnClick={props.printPickingListOnClick}
        printCourseDeliveryCountReportOnClick={props.printCourseDeliveryCountReportOnClick}
        printDeliveryByCourseReportOnClick={props.printDeliveryByCourseReportOnClick}
        downloadPlanCsvPerPacketOnClick={props.downloadPlanCsvPerPacketOnClick}
        downloadPlanCsvPerPlaceOnClick={props.downloadPlanCsvPerPlaceOnClick}
      />
    </Dialog>
    <DirectionSettingDialog
      open={props.directionSettingDialogOpen}
      onClose={props.onCloseDirectionSetting}
      width="md"
      navigateToPath={props.printOperationDirectionUrl()}
    />
    <ShipperSelectDialog
      open={props.shipperDialogOpen}
      shipperNames={props.shipperOptionsNames}
      isLoading={props.shipperOptionsIsLoading}
      isError={props.shipperOptionsIsError}
      barcodeSelectable={props.shipperDialogMode === 'picking-list'}
      onBack={props.onShipperDialogBack}
      onConfirm={props.onShipperDialogConfirm}
    />
  </>
));

export default ReportPrintingDialogs;
